import React from "react";
import PropTypes from "prop-types";
import "./MultiSelect.scss";

const MultiSelect = ({ label, option, answer, idx, onChange }) => {
  return (
    <div className="multiSelect-container col-6 mb-4">
      <div className="form-check">
        <input
          className="form-check-input check-primary"
          type="checkbox"
          onChange={onChange}
          checked={new Set(answer).has(idx)}
          value={idx}
          label={label}
          id={"radio" + option.toUpperCase()}
        />
        <label
          className="form-check-label d-flex align-items-center text-primary"
          htmlFor={"radio" + option.toUpperCase()}
        >
          <span>
            <span className="bg-primary option-box text-white text-center px-1 rounded-circle me-2 d-flex justify-content-center align-items-center">{`${option.toUpperCase()} `}</span>
          </span>

          <span> {label}</span>
        </label>
      </div>
    </div>
  );
};

MultiSelect.propTypes = {
  option: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  answer: PropTypes.array,
  idx: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default MultiSelect;
